import React from 'react';
import Button from 'react-bootstrap/Button';
import ResponseKeyValue from 'components/transactionEditor/ResponseKeyValue';
import i18n from 'i18n';
import BzmIcon from '../icons/BzmIcon';
import { getUniqueIndex } from 'components/transactionEditor/RequestMatchersList';
import { MessagePropertyType } from '../../types/rest/dslTypes';

export interface ResponseKeyValueItem {
  id: string;
  name: string | null;
  value: string | null;
  type?: MessagePropertyType;
  [key: string]: string | null | MessagePropertyType;
}

interface ResponseHeadersListProps {
  id: string;
  responseItemList: ResponseKeyValueItem[] | null;
  emptyListMessage: string;
  onListChange: (list: ResponseKeyValueItem[]) => void;
  isReadOnly?: boolean;
  resHeaderInvalidMagicStrings?: string;
  isResponseHeaderMagicStringInvalid?: boolean;
  validateName?: boolean;
  isMessageProperty?: boolean;
  enableAiAssistant?: boolean; // Flag to enable AI assistant functionality
  transactionId?: number;
  multilineValue?: boolean;
}

const ResponseKeyValueList = (props: ResponseHeadersListProps) => {
  const handleAddNew = () => {
    const index = props.responseItemList ? props.responseItemList.length : 0;
    const emptyItem = {
      id: 'header-item-' + getUniqueIndex(props.responseItemList),
    } as ResponseKeyValueItem;
    if (props.isMessageProperty) {
      emptyItem.type = MessagePropertyType.STRING;
    }
    const list = props.responseItemList ? props.responseItemList.concat(emptyItem) : [emptyItem];
    props.onListChange(list);
  };

  const handleDelete = (id: string) => {
    if (props.responseItemList) {
      const list = props.responseItemList.filter((item: ResponseKeyValueItem) => item.id !== id);
      props.onListChange(list);
    }
  };

  const handleChange = (name: string, value: string, id: string) => {
    if (props.responseItemList) {
      const list = [...props.responseItemList];
      const index: number = list.findIndex(item => item.id === id);
      list[index][name] = value;
      props.onListChange(list);
    }
  };

  if (props.responseItemList && props.responseItemList.length > 0) {
    const length = props.responseItemList.length;
    return (
      <div id={props.id}>
        {props.isResponseHeaderMagicStringInvalid && props.resHeaderInvalidMagicStrings && (
          <div>
            <div className="invalid-feedback">{props.resHeaderInvalidMagicStrings} syntax is incorrect.</div>
            <p>
              <span className="pb-5"></span>
            </p>
          </div>
        )}
        {props.responseItemList.map((item: ResponseKeyValueItem, index: number) => (
          <ResponseKeyValue
            isReadOnly={props.isReadOnly}
            onChange={handleChange}
            onAdd={handleAddNew}
            onDelete={() => handleDelete(item.id)}
            displayAdd={index === length - 1}
            key={item.id}
            id={item.id}
            responseItem={item}
            validateName={props.validateName}
            isMessageProperty={props.isMessageProperty}
            enableAiAssistant={props.enableAiAssistant}
            transactionId={props.transactionId}
            multilineValue={props.multilineValue}
          />
        ))}
      </div>
    );
  }

  return (
    <div id={props.id}>
      <p>{props.emptyListMessage}</p>
      {!props.isReadOnly && (
        <Button
          id="qa-btn-resp-header-add-first"
          onClick={() => handleAddNew()}
          className="btn-circular"
          title={i18n.t('transactions:editor.addResponseHeader')}
        >
          <BzmIcon variant={'icon-bzm-add'} />
        </Button>
      )}
    </div>
  );
};

export default ResponseKeyValueList;
